import { useOrganization } from "data/use-organization.js";

export const useStateKeyPrefix = ({ stateKeyPrefix }) => {
  const organization = useOrganization();

  if (stateKeyPrefix) {
    return `${stateKeyPrefix}.${organization._id}.`;
  }

  return `${organization._id}.`;
};
